<template>
    <div class="table-container">
        <div class="row">
            <div class="col-md-2">
                <label class="form-label" for="userAccount">受訓編號</label>
                <input class="form-control" type="text" id="userAccount" v-model="userAccount" />
            </div>

            <!-- <div class="col-md-2">
                <label class="form-label" for="endDate">姓名</label>
                <input class="form-control" type="date" id="endDate" v-model="endDate" />
            </div> -->

            <div class="col-md-2">
                <button @click="submitQuery" class="btn btn-primary btn-sm" style="margin-top: 35px;">查詢</button>
            </div>
        </div>
        <hr>
        <!-- @click-row="handleRowClick" -->
        <EasyDataTable table-class-name="customize-table" buttons-pagination :headers="tableColumns" :items="tableData">
            <template #item-operation="item">
                <div class="operation-wrapper">
                    <button @click="handleRowClick(item)" class="btn btn-primary btn-sm">進入</button>
                </div>
            </template>
        </EasyDataTable>
    </div>
</template>
  
<script>
import axios from 'axios'

export default {

    data() {
        return {
            systemName: window.VUE_APP_System, //recommend //behavior
            isDev: window.VUE_APP_Dev,
            myLiffId: '2002453323-20Lo31Kp',
            lineLoginChannelID: '2002453323', // Replace this with your Line Login Channel ID
            linecode: '',
            userRole: '',
            userAccount: '',
            startDate: '',
            endDate: '',
            sportType: '',
            tableData: [],
            tableColumns: [
                { text: "單位", value: "siteName" },
                { text: "姓名", value: "userName" },
                { text: "受訓編號", value: "userAccount" },
                { text: "身分", value: "userRole" },
                { text: "", value: "operation" },

            ],

        }
    },
    beforeMount() {
        this.linecode = localStorage.getItem("linecode");

        if (this.isDev == '1') {
            this.linecode = 'U2d06679ce81e3c95809062c2c48d517b'
        }
        if (this.linecode) {
            this.getUser(this.linecode);
        }else {
            this.$router.push({ name: "HomePage" });
        }
    },
    mounted() {
        this.systemName = window.VUE_APP_System;
        if (this.systemName == "recommend") {
            //運動建議
            this.sportType = '運動項目推薦'
        } else {
            //運動行為
            this.sportType = '運動行為調查'
        }
        this.getListing();
    },
    methods: {
        getUser(x) {
            const self = this;
            // 呼叫API獲取資料
            axios.get('https://147isrgvqd.execute-api.ap-northeast-1.amazonaws.com/getUser', {
                params: {
                    survey_type: self.systemName,
                    userId: x, // 這裡設置您的條件
                },
            })
                .then(response => {
                    if (response.data) {
                        self.userRole = response.data.userRole;
                        localStorage.setItem("userRole", response.data.userRole);
                        self.isShowUserListBtn = true;
                    } else {
                        self.$router.push({ name: "HomePage" });

                    }
                })
                .catch(error => {
                    console.error('無法獲取資料：', error)
                })
        },
        getListing() {
            const self = this;
            // 呼叫API獲取資料
            axios.get('https://147isrgvqd.execute-api.ap-northeast-1.amazonaws.com/get_all_user', {
                params: {
                    sportType: self.sportType, // 這裡設置您的條件
                },
            })
                .then(response => {
                    // 將API回傳的資料設定給tableData
                    //   this.tableData = response.data;
                    response.data.forEach(item => {
                        // 從每一筆資料中取出所需的欄位
                        const SK = item.SK;
                        const PK = item.PK;
                        const siteName = item.siteName;
                        const userName = item.userName;
                        const userAccount = item.userAccount;
                        const userRole = item.userRole;

                        // 將解析後的資料組成一個物件
                        const rowData = {
                            PK,
                            SK,
                            siteName,
                            userName,
                            userAccount,
                            userRole,
                        };

                        // 將rowData物件加入到this.tableData陣列中
                        this.tableData.push(rowData);
                    });
                })
                .catch(error => {
                    console.error('無法獲取資料：', error)
                })
        },
        openPageDetail(PK, SK) {
            this.$router.push({
                    path: '/user',
                    query: {
                        PK: PK,
                        SK: SK,
                    }
                });
        },
        handleRowClick(item) {
            const PK = item.PK;
            const SK = item.SK;
            this.openPageDetail(PK, SK);
        },
        submitQuery() {
            const self = this;
            this.tableData = [];

            // 發送GET請求到後端API
            axios.get('https://147isrgvqd.execute-api.ap-northeast-1.amazonaws.com/search_user_data', {
                params: {
                    sportType: self.sportType, // 這裡設置您的條件
                    userAccount: self.userAccount,
                },
            })
                .then(response => {
                    // 成功取得資料
                    response.data.forEach(item => {
                        // 從每一筆資料中取出所需的欄位
                        const SK = item.SK;
                        const PK = item.PK;
                        const siteName = item.siteName;
                        const userName = item.userName;
                        const userAccount = item.userAccount;
                        const userRole = item.userRole;

                        // 將解析後的資料組成一個物件
                        const rowData = {
                            PK,
                            SK,
                            siteName,
                            userName,
                            userAccount,
                            userRole,
                        };

                        // 將rowData物件加入到this.tableData陣列中
                        this.tableData.push(rowData);
                    });
                })
                .catch(error => {
                    // 處理錯誤
                    console.error('錯誤：', error);
                });
        },
    }
}
</script>
<style scoped>
.table-container {
    margin: 20px 30px 30px 30px;
    /* 設置上下左右的邊距，你可以根據需要調整數值 */
}

.customize-table>table {
    width: 100% !important;
}

table[data-v-32683533] {
    width: 100% !important;
}


.table-container {
    /* background: #DFD6C8; */
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
}

.table-container .row {
    margin-bottom: 10px;
}

.table-container .form-label {
    color: #616161;
    font-weight: bold;
    margin-bottom: 5px;
}

.table-container .form-control {
    border: 1px solid #A79B7E;
    background-color: #EFEDE1;
    color: #867A5C;
}

.table-container .form-control:focus {
    border-color: #D3A17E;
    box-shadow: 0 0 0 0.2rem rgba(211, 161, 126, 0.25);
}

.table-container .btn-primary {
    background-color: #CC785C;
    border-color: #D3A17E;
    color: #EFEDE1;
}

.table-container .btn-primary:hover {
    background-color: #D3A17E;
}

.table-container hr {
    border-top: 1px solid #A79B7E;
}

/* 整體背景與文字顏色 */
.table-container {
    /* background-color: #DFD6C8;  */
    color: #616161;
}

.form-label {
    color: #867A5C;
    /* 標籤文字使用較深的棕灰色 */
}

.form-control {
    background-color: #EFEDE1;
    /* 輸入框使用象牙色 */
    border: 1px solid #A79B7E;
    /* 邊框使用暖灰色 */
    color: #616161;
    /* 輸入文字使用深灰色 */
}

.form-control:focus {
    border-color: #CC785C;
    /* 輸入框聚焦時的邊框色 */
    box-shadow: 0 0 0 0.2rem rgba(205, 120, 92, 0.25);
    /* 聚焦時的陰影 */
}

.btn-primary {
    background-color: #CC785C;
    /* 按鈕使用銅紅色 */
    border-color: #D3A17E;
    /* 按鈕邊框使用淡粉棕色 */
    color: #EFEDE1;
    /* 按鈕文字使用象牙色 */
}

.btn-primary:hover {
    background-color: #D3A17E;
    /* 鼠標懸停時的按鈕背景色 */
    border-color: #CC785C;
    /* 鼠標懸停時的按鈕邊框色 */
}


.customize-table {

    --easy-table-border: 1px solid #DFD6C8;
    --easy-table-row-border: 1px solid #DFD6C8;

    --easy-table-header-font-size: 16px;
    --easy-table-header-height: 50px;
    --easy-table-header-font-color: #616161;
    /* 修改表頭字體顏色 */
    --easy-table-header-background-color: #DFD6C8;
    /* 修改表頭背景色 */

    --easy-table-header-item-padding: 10px 15px;

    --easy-table-body-even-row-font-color: #616161;
    /* 修改表體偶數行字體顏色 */
    --easy-table-body-even-row-background-color: #DFD6C8;
    /* 修改表體偶數行背景色 */

    --easy-table-body-row-font-color: #616161;
    /* 修改表體行字體顏色 */
    --easy-table-body-row-background-color: #EFEDE6;
    /* 修改表體行背景色 */
    --easy-table-body-row-height: 50px;
    --easy-table-body-row-font-size: 16px;

    --easy-table-body-row-hover-font-color: #616161;
    /* 修改表體行懸停字體顏色 */
    --easy-table-body-row-hover-background-color: #DFD6C8;
    /* 修改表體行懸停背景色 */
    --easy-table-body-item-padding: 10px 15px;

    --easy-table-footer-background-color: #EFEDE6;
    /* 修改表尾背景色 */
    --easy-table-footer-font-color: #616161;
    /* 修改表尾字體顏色 */
    --easy-table-footer-font-size: 16px;
    --easy-table-footer-padding: 0px 10px;
    --easy-table-footer-height: 50px;

    --easy-table-rows-per-page-selector-width: 70px;
    --easy-table-rows-per-page-selector-option-padding: 10px;
    --easy-table-rows-per-page-selector-z-index: 1;

    --easy-table-scrollbar-track-color: #445269;
    --easy-table-scrollbar-color: #445269;
    --easy-table-scrollbar-thumb-color: #4c5d7a;
    --easy-table-scrollbar-corner-color: #445269;

    --easy-table-loading-mask-background-color: #445269;
}
</style>